import '@babel/polyfill'
import Vue from 'vue'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
//////////////////////////////////////////////////////////////// Fullpage JS
import VueFullPage from 'vue-fullpage.js'
Vue.use(VueFullPage)

//////////////////////////////////////////////////////////////// Cookies Message
import CookiesMsg from './plugins/cookies-msg/index.js'
Vue.use(CookiesMsg)

//////////////////////////////////////////////////////////////// Site Drawer
// import SiteDrawer from './plugins/site-drawer/index.js'
// Vue.use(SiteDrawer)

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -200,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/index.vue'
Vue.component('BgImage', BgImage)

//////////////////////////////////////////////////////////////// Background Video
import BgVideo from './components/bg-video/index.vue'
Vue.component('BgVideo', BgVideo)

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES
//////////////////////////////////////////////////////////////// Gsap
import Gsap from './directives/gsap/index.js'
Vue.directive('Gsap', Gsap)

/////////////////////////////////////////////////////////////////////////////////////////////////// App Components
// import router from './router'

import StickyElement from './components/sticky-element/index.vue'
import GoogleMap from './google-map.vue'
// const GoogleMap = () => import('./google-map.vue')

// import {
//     devices
// } from './imports/utils'

var app = new Vue({
    el: '#app',
    // router,
    components: {
        StickyElement,
        GoogleMap
    },
    data() {
        return {
            lang: document.getElementById('app').getAttribute('lang'),
            showMenu: false,
            fullpageOptions: {
                licenseKey: '7CA154FB-0BBF482F-99944FCD-C00AAD66',
                // navigation: true,
                // menu: '#menu',
                // anchors: ['home', 'flagOfGreece', 'flag', 'exhibition', 'footer'],
                // fixedElements: '.side, #header, #side',
                verticalCentered: true,
                parallax: true,
                // parallaxOptions: {
                //     type: 'reveal',
                //     percentage: 62,
                //     property: 'translate'
                // },
                // normalScrollElements: '.fp-content-overflow',
                responsiveWidth: 768
            },
            // isDevice: devices(),
            // windowWidth: window.innerWidth,
        }
    },
    methods: {
        // onResize() {
        //     this.windowWidth = window.innerWidth
        // }
        onScroll() {
            if (this.showMenu) {
                this.showMenu = false
            }
        },
        toggleMenu() {
            this.showMenu = !this.showMenu
        }
    },
    created() {
        // window.addEventListener("resize", this.onResize, {
        //     passive: false
        // })

        window.addEventListener("scroll", this.onScroll, {
            passive: false
        })

        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
    destroyed() {
        // window.removeEventListener("resize", this.onResize)
        window.removeEventListener("scroll")
    }
})